/* eslint-disable @typescript-eslint/no-explicit-any */
import { toast } from 'src/utils/notification';
import { hashExists } from './hashExists';
import { sanitizeFile } from './sanitizeFile';
import { getAllowedMimeTypes } from './getAllowedMimeTypes';

export  const onSelectFile = (args: any, fileTypes, modalStates, uploaderInstance, files, setFiles) => {

  args.filesData.forEach(async (file: any) => {
    await sanitizeFile(file, fileTypes)
      .then(async () => {
        await hashExists(modalStates.multiUpload.widgetData.upload, file.hash)
          .then((exists) => {
            let error = false;

            if (exists === true) {
              error = true;
              toast.warning('File already exists on server: ', file.name);
              args.cancel = true;
              uploaderInstance.remove(file);
            }
            if (files.some(element => file.rawFile.hash === element.hash)) {
              error = true;
              toast.warning('File already exists in the upload list: ', file.name);
              args.cancel = true;
              uploaderInstance.remove(file);
            }
            if (!getAllowedMimeTypes(fileTypes).includes(file.mime)) {
              error = true;
              toast.warning(`MIME type ${file.mime} is not allowed: `, file.name);
              args.cancel = true;
              uploaderInstance.remove(file);
            }
            if (file.statusCode === '0') {
              error = true;

              toast.warning(`File type ${file.type} is not allowed: `, file.name);
              args.cancel = true;
              uploaderInstance.remove(file);
            }
            if (error === false)
              setFiles(files => [...files, file?.rawFile]);
          });

      });
  });
};